import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsFeedbackLazy = loadable(
    () => import(/* webpackChunkName: "SettingsFeedback" */ './SettingsFeedbackSuspense')
);

export const SettingsFeedbackAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsFeedbackLazy />
    </DelayedSuspense>
);
